import artifact from '$houdini/artifacts/LoginMutation'
import { MutationStore } from '../runtime/stores/mutation'

export class LoginMutationStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
